var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g4, _path24, _path25, _g5, _path26, _path27, _g6, _path28, _path29, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 82,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error-empty_svg__clip0_4473_29983)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.174 50.105l58.531 31.844c.702.36 3.985-1.226 3.985-1.943l.349-49.082c0-.331-.2-.637-.524-.803L6.265.051c-.701-.36-3.16 1.255-3.163 1.971l.552 47.273c0 .335.199.644.527.81h-.007z",
    fill: "url(#error-empty_svg__paint0_linear_4473_29983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.704 60.978l-8.985 3.584c-.36.194-.321 1.92.042 2.111L34.873 76.83a.598.598 0 00.559 0l9.121-4.924c.363-.197.43-1.901.067-2.092l-19.36-8.839a.593.593 0 00-.553.003h-.003z",
    fill: "#C1C1C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.704 59.708l-8.947 4.831a.483.483 0 000 .867L34.87 75.563a.598.598 0 00.558 0l9.122-4.924a.48.48 0 00-.007-.867l-19.29-10.064a.593.593 0 00-.552.003l.003-.003z",
    fill: "url(#error-empty_svg__paint1_linear_4473_29983)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.16 67.173l7.369 3.806.048-7.736-7.368-3.88-.049 7.81z",
    fill: "url(#error-empty_svg__paint2_linear_4473_29983)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.21 59.364l.638-.386 7.365 3.88-.049 7.74-.635.382.048-7.737-7.368-3.88z",
    fill: "#C1C1C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.697 50.796l59.802 31.026c.706.36 1.938-.09 1.938-.803V32.574c0-.331-.199-.637-.527-.803L4.446 1.382c-.705-.36-1.589.083-1.592.796l-.685 47.809c0 .334.2.643.528.809z",
    fill: "url(#error-empty_svg__paint3_linear_4473_29983)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.848 49.203l57.658 29.889V33.539L5.515 4.297l-.667 44.906z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31,
    fill: "#2C2F30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.882 17.19l-1.704-.898c-.38-.201-.688-.08-.688.264v1.554c0 .348.307.787.688.988l1.704.898c.38.2.688.08.688-.264v-1.555c0-.347-.307-.787-.688-.987zM15.652 18.687l9.485 4.994c.171.09.31.038.31-.121 0-.156-.139-.357-.31-.446l-9.485-4.994c-.17-.09-.31-.038-.31.12 0 .16.14.358.31.447zM15.652 19.808l13.24 6.972c.17.09.31.038.31-.12 0-.157-.14-.358-.31-.447l-13.24-6.972c-.17-.089-.31-.038-.31.121 0 .16.14.357.31.446zM28.891 27.334l-13.238-6.972c-.172-.089-.311-.038-.311.121 0 .16.14.357.31.446l13.24 6.972c.17.09.31.039.31-.12 0-.16-.14-.357-.31-.447z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31,
    fill: "#2C2F30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.882 24.006l-1.704-.898c-.38-.2-.688-.08-.688.264v1.555c0 .347.307.786.688.987l1.704.898c.38.2.688.08.688-.264v-1.555c0-.347-.307-.786-.688-.987zM15.652 25.503l9.485 4.994c.171.09.31.038.31-.12 0-.157-.139-.358-.31-.447l-9.485-4.994c-.17-.09-.31-.038-.31.121 0 .16.14.357.31.446zM15.652 26.624l13.24 6.972c.17.09.31.039.31-.12 0-.157-.14-.357-.31-.447l-13.24-6.972c-.17-.089-.31-.038-.31.121 0 .16.14.357.31.446zM28.891 34.15l-13.238-6.972c-.172-.089-.311-.038-.311.121 0 .16.14.357.31.446l13.24 6.973c.17.089.31.038.31-.122 0-.159-.14-.356-.31-.445z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31,
    fill: "#2C2F30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.882 29.88l-1.704-.899c-.38-.2-.688-.08-.688.264V30.8c0 .347.307.787.688.987l1.704.898c.38.201.688.08.688-.264v-1.554c0-.348-.307-.787-.688-.988zM15.652 31.376l9.485 4.994c.171.09.31.039.31-.12 0-.157-.139-.357-.31-.447l-9.485-4.994c-.17-.089-.31-.038-.31.121 0 .16.14.357.31.446zM15.652 32.498l13.24 6.972c.17.089.31.038.31-.121 0-.156-.14-.357-.31-.446l-13.24-6.972c-.17-.09-.31-.039-.31.12 0 .16.14.357.31.447zM28.891 40.024l-13.238-6.972c-.172-.09-.311-.038-.311.12 0 .16.14.358.31.447l13.24 6.972c.17.089.31.038.31-.121 0-.16-.14-.357-.31-.446z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.82 59.14v.224l4.043 2.089v-.22l-4.044-2.092z",
    fill: "#ADADAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.82 59.14l4.033-2.137 4.005 2.112-3.995 2.118-4.044-2.092z",
    fill: "#D6D6D6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.863 61.453l3.995-2.118v-.22l-3.995 2.118v.22z",
    fill: "#D6D6D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.86 58.532v4.017l4.045 2.089v-4.013l-4.044-2.093z",
    fill: "#ADADAD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.905 60.625l3.995-2.121v4.016l-3.995 2.118v-4.013z",
    fill: "#D6D6D6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9 58.504l-4.006-2.109-4.033 2.137 4.044 2.093 3.995-2.121z",
    fill: "#D6D6D6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.79 57.962v7.705l4.044 2.093v-7.708l-4.044-2.09z",
    fill: "#ADADAD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.834 60.052l3.995-2.118v7.707l-3.995 2.119v-7.708z",
    fill: "#D6D6D6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.79 57.962l4.034-2.137 4.005 2.108-3.995 2.119-4.044-2.09z",
    fill: "#D6D6D6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24 66.403l2.385 1.258c.29.153.643.153.933 0l.758-.38a.41.41 0 000-.738L5.93 65.285a1.005 1.005 0 00-.932 0l-.758.379a.41.41 0 000 .739z",
    fill: "#2E2F2E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.763 60.762l1.23-.653c.313-.166.75-.13 1.256.137l-1.229.653c-.506-.268-.943-.303-1.257-.137z",
    fill: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02 60.896c1.034.544 1.743 1.726 1.74 2.873-.004 1.146-.685 1.563-1.782.987-1.037-.545-1.742-1.755-1.739-2.841.004-1.143.747-1.564 1.781-1.02z",
    fill: "#000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.475 64.253l-1.23.653c.33-.175.514-.574.514-1.137.004-1.144-.705-2.329-1.739-2.873l1.23-.653c1.033.544 1.742 1.726 1.738 2.873 0 .563-.185.962-.513 1.137zM8.18 58.313l1.232-.653.028.821-1.23.653-.03-.821zM3.28 42.438l1.23-.653c.977-.232 2.667.163 4.235.988l-1.229.652c-1.568-.824-3.258-1.22-4.236-.987z",
    fill: "#000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.516 43.425c3.401 1.794 4.934 4.803 4.927 7.16-.007 2.109-1.135 3.039-2.56 4.055-1.305.927-1.784 2.042-1.7 3.67l.028.821-2.308-1.217-.06-.837c-.17-1.768.367-3.32 1.851-4.399 1.338-.943 2.081-1.761 2.085-3.156.003-1.583-.94-3.134-2.804-4.147-1.065-.56-2.25-.813-2.99-.612l-.705-2.328c.978-.233 2.668.162 4.236.987v.003z",
    fill: "#000"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.516 43.425l1.23-.652c3.4 1.793 4.934 4.803 4.927 7.16-.007 2.108-1.135 3.038-2.56 4.054-1.306.927-1.785 2.042-1.7 3.67l-1.23.652c-.08-1.627.395-2.742 1.7-3.669 1.425-1.02 2.553-1.95 2.56-4.054.007-2.358-1.522-5.37-4.927-7.16z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "error-empty_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 60,
    width: 4,
    height: 2
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.733 61.377l1.229-.653c.314-.166.75-.13 1.257.137l-1.23.653c-.506-.268-.942-.303-1.256-.137z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#error-empty_svg__a)",
    fill: "#F4B648"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.733 61.377l1.229-.653.042-.023-1.23.653s-.027.013-.041.023zM4.778 61.355l1.23-.653.07-.03-1.23.654c-.025.01-.049.019-.07.029z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.848 61.326l1.23-.653c.02-.006.045-.016.069-.022l-1.23.653a.571.571 0 00-.07.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.918 61.303l1.229-.653c.02-.006.042-.01.063-.012l-1.23.653c-.02.003-.041.01-.062.012z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98 61.29l1.23-.652.063-.01-1.23.653c-.02 0-.041.007-.062.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.043 61.281l1.23-.653c.02 0 .042-.003.063-.006l-1.23.653c-.02 0-.042 0-.063.006zM5.106 61.275l1.23-.653h.062l-1.229.653h-.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17 61.275l1.228-.653h.063l-1.229.653H5.17zM5.232 61.278l1.23-.653a.21.21 0 01.062.007l-1.23.653c-.02 0-.041-.004-.062-.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.295 61.281l1.23-.653c.02 0 .041.007.065.01l-1.229.653a2.985 2.985 0 00-.066-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.361 61.29l1.23-.652c.02.003.045.006.066.012l-1.23.653c-.02-.003-.045-.01-.066-.012zM5.428 61.304l1.229-.653c.02.003.045.01.07.016l-1.23.652-.07-.015z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.497 61.32l1.23-.654.07.02-1.23.653a1.883 1.883 0 01-.07-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.567 61.339l1.23-.654c.024.007.048.017.073.023l-1.23.653c-.024-.01-.048-.016-.073-.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64 61.36l1.23-.652c.024.01.052.019.08.028l-1.23.653c-.027-.01-.051-.019-.08-.028zM5.721 61.39l1.23-.653c.027.01.055.022.083.035l-1.23.653c-.027-.013-.055-.023-.083-.035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.805 61.424l1.229-.652c.031.012.06.025.09.04l-1.229.654a1.177 1.177 0 00-.09-.042zM5.896 61.466l1.229-.653.094.048-1.23.653-.093-.048z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99 61.514c1.033.544 1.742 1.726 1.739 2.872 0 1.083-.688 1.561-1.785.985-1.033-.545-1.742-1.755-1.739-2.838.004-1.147.744-1.564 1.781-1.02h.004z",
    fill: "#F4B648"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "error-empty_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 60,
    width: 4,
    height: 6
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.445 64.867l-1.23.653c.329-.175.514-.573.514-1.133.003-1.147-.706-2.329-1.74-2.873l1.23-.653c1.034.544 1.743 1.726 1.739 2.873 0 .56-.185.958-.513 1.133z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#error-empty_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99 61.514l1.232-.653-1.229.653H5.99zM5.994 61.514l1.229-.653c.035.019.07.038.101.057l-1.23.653-.1-.057z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.094 61.57l1.23-.652c.035.02.066.041.101.06l-1.23.653a1.689 1.689 0 00-.1-.06z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.196 61.632l1.229-.654c.035.023.066.045.101.067l-1.229.653a2.668 2.668 0 00-.101-.066zM6.297 61.698l1.23-.653c.03.023.062.045.094.067l-1.23.653a50.933 50.933 0 00-.094-.067z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.388 61.765l1.229-.653c.028.023.06.045.087.067l-1.229.653-.087-.067z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.475 61.832l1.23-.653c.027.023.052.045.08.067l-1.23.653c-.028-.022-.052-.045-.08-.067z",
    fill: "#F5BF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.555 61.899l1.23-.653c.024.022.049.045.073.064l-1.23.653a1.302 1.302 0 00-.073-.064z",
    fill: "#F6C267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.629 61.963l1.229-.653c.024.022.049.044.07.067l-1.23.653c-.024-.023-.045-.045-.07-.067z",
    fill: "#F6C56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.699 62.03l1.229-.654a.85.85 0 01.077.08l-1.23.653-.076-.08z",
    fill: "#F7C874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.779 62.11l1.23-.654c.038.038.072.077.107.118l-1.229.653c-.035-.041-.073-.08-.108-.118z",
    fill: "#F7CA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.887 62.227l1.23-.653.122.147-1.23.652c-.038-.05-.08-.098-.122-.146z",
    fill: "#F7CB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.006 62.37l1.23-.653c.027.038.059.077.087.115l-1.23.653c-.028-.038-.056-.077-.087-.115z",
    fill: "#F7CA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.093 62.485l1.23-.653.052.076-1.23.653-.052-.076z",
    fill: "#F7C874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.146 62.561l1.229-.653c.014.02.024.039.038.058l-1.229.653-.038-.058z",
    fill: "#F6C56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.184 62.619l1.23-.653c.01.019.024.038.034.054l-1.229.653c-.01-.02-.024-.038-.035-.054z",
    fill: "#F6C267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.219 62.676l1.23-.653c.01.02.024.038.034.054l-1.23.653a.301.301 0 00-.034-.054z",
    fill: "#F5BF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.254 62.73l1.23-.653.03.055-1.229.653c-.01-.02-.02-.036-.031-.055z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.285 62.784l1.23-.653.03.054-1.228.653c-.01-.019-.021-.035-.032-.054zM7.317 62.839l1.229-.654.031.058-1.229.653-.031-.057z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.348 62.893l1.23-.653.03.06-1.228.653-.032-.06z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.376 62.953l1.23-.653.03.06-1.228.654c-.011-.02-.021-.042-.032-.06z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.408 63.014l1.229-.653.031.067-1.229.653-.031-.067z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.439 63.08l1.23-.652.03.07-1.229.653c-.01-.023-.02-.048-.031-.07z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47 63.15l1.23-.652.031.073-1.23.653-.03-.073z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.498 63.224l1.23-.653.03.08-1.228.653-.032-.08z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53 63.304l1.229-.653c.01.025.021.054.028.08l-1.23.652c-.01-.025-.017-.054-.027-.08z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.558 63.383l1.229-.653c.01.029.017.058.028.086l-1.23.653-.027-.086z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.586 63.466l1.229-.653c.01.029.017.057.024.086l-1.229.653c-.007-.029-.017-.057-.024-.086zM7.614 63.555l1.229-.653.024.09-1.229.653c-.007-.03-.014-.061-.024-.09z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.638 63.644l1.23-.652.02.092-1.229.653c-.007-.032-.014-.06-.02-.093zM7.659 63.737l1.23-.653.02.095-1.23.653-.02-.095zM7.68 63.832l1.23-.653c.006.032.01.067.017.1l-1.23.652a.972.972 0 00-.017-.099z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.694 63.931l1.23-.653c.006.035.01.067.013.102l-1.23.653c-.003-.035-.01-.07-.013-.102zM7.708 64.033l1.23-.653.01.111-1.23.653c0-.038-.007-.073-.01-.111zM7.722 64.144l1.229-.653c0 .039.007.08.007.118l-1.23.653c0-.038-.003-.08-.006-.118z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.729 64.262l1.229-.653v.121l-1.23.653v-.12zM7.729 64.387l1.23-.653c0 .041 0 .086-.004.124l-1.23.653c0-.042.004-.083.004-.124zM7.725 64.514l1.23-.653c0 .044-.007.086-.01.13l-1.23.653.01-.13z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.715 64.641l1.229-.653-.02.137-1.23.653.02-.137zM7.694 64.781l1.23-.653c-.011.055-.025.109-.04.156l-1.228.653c.013-.05.027-.102.038-.156zM7.655 64.938l1.23-.653c-.084.274-.234.471-.44.583l-1.23.653c.206-.112.357-.31.44-.583z",
    fill: "#F4B648"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.153 58.924l1.232-.653.028.825-1.232.653-.028-.825z",
    fill: "#F4B648"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "error-empty_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 42,
    width: 6,
    height: 3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.253 43.05l1.23-.653c.977-.23 2.667.162 4.235.987l-1.229.653c-1.568-.825-3.258-1.217-4.236-.987z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#error-empty_svg__c)",
    fill: "#F4B648"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.253 43.05l1.23-.653c.034-.01.07-.016.104-.023l-1.229.653c-.035.007-.073.013-.105.023zM2.362 43.027l1.229-.653c.052-.01.105-.016.16-.022l-1.229.653a2.403 2.403 0 00-.16.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.522 43.005l1.23-.653c.059-.006.118-.013.178-.016l-1.23.653c-.063 0-.122.01-.178.016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7 42.989l1.23-.653c.066-.003.132-.006.199-.003l-1.23.653c-.07 0-.136 0-.199.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9 42.986l1.229-.653c.073 0 .146 0 .223.006l-1.23.653c-.076-.003-.15-.006-.223-.006zM3.123 42.992l1.229-.653c.08.004.164.013.248.02l-1.23.652a3.429 3.429 0 00-.247-.019zM3.367 43.014l1.23-.652c.087.01.178.022.272.035l-1.23.653c-.09-.016-.18-.026-.272-.035zM3.64 43.05l1.229-.653c.098.016.195.032.297.054l-1.23.653c-.1-.02-.199-.038-.296-.054zM3.937 43.104l1.229-.653c.105.022.213.044.321.073l-1.23.653c-.107-.026-.216-.051-.32-.073z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.261 43.174l1.23-.653.342.092-1.23.653c-.115-.035-.23-.063-.342-.092zM4.604 43.27l1.229-.654c.118.035.24.074.363.115l-1.23.653a9.57 9.57 0 00-.362-.115zM4.967 43.384l1.229-.653c.126.042.251.086.377.137l-1.23.653c-.125-.048-.25-.092-.376-.137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.344 43.518l1.23-.653c.128.047.254.102.383.156l-1.229.653c-.13-.054-.258-.108-.384-.156zM5.728 43.674l1.23-.653c.128.054.254.115.383.175l-1.229.653c-.13-.06-.255-.118-.384-.175zM6.112 43.849l1.23-.653c.125.06.25.124.376.188l-1.229.653a6.889 6.889 0 00-.377-.188z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49 44.037c3.4 1.793 4.934 4.806 4.927 7.16-.007 2.109-1.135 3.039-2.56 4.055-1.306.926-1.785 2.041-1.7 3.669l.027.822-2.308-1.217-.06-.838c-.174-1.77.367-3.319 1.851-4.398 1.338-.943 2.082-1.762 2.085-3.157.004-1.583-.94-3.134-2.804-4.147-1.065-.56-2.252-.812-2.99-.611l-.705-2.329c.978-.229 2.668.163 4.236.988v.003z",
    fill: "#F4B648"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "error-empty_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 43,
    width: 7,
    height: 16
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49 44.037l1.228-.653c3.402 1.793 4.935 4.806 4.928 7.16-.007 2.109-1.135 3.039-2.56 4.055-1.306.927-1.784 2.041-1.7 3.669l-1.23.653c-.084-1.628.395-2.742 1.7-3.67 1.426-1.019 2.554-1.949 2.56-4.054.008-2.357-1.522-5.37-4.927-7.16z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#error-empty_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49 44.037l1.228-.653h.004l-1.23.653H6.49zM6.493 44.04l1.23-.652c.132.07.265.143.394.216l-1.23.653c-.129-.073-.258-.146-.394-.217zM6.887 44.26l1.23-.653c.125.073.251.15.373.226l-1.229.653a14.007 14.007 0 00-.374-.226zM7.261 44.486l1.23-.653c.118.076.233.153.348.23l-1.229.652a6.338 6.338 0 00-.349-.229z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61 44.715l1.23-.653c.108.077.216.153.317.23l-1.229.653-.318-.23z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.928 44.945l1.23-.653c.093.07.184.14.275.213l-1.23.653a8.679 8.679 0 00-.275-.213z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.204 45.158l1.23-.653c.083.067.163.134.244.204l-1.23.653c-.08-.07-.16-.137-.244-.204z",
    fill: "#F5BF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.448 45.362l1.23-.653c.076.067.15.13.223.197l-1.23.653c-.072-.066-.146-.133-.223-.197z",
    fill: "#F6C267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.675 45.563l1.23-.653c.073.067.143.13.213.2l-1.23.653c-.07-.067-.14-.133-.213-.2z",
    fill: "#F6C56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.885 45.76l1.23-.653c.072.07.142.144.212.214l-1.23.653a6.514 6.514 0 00-.212-.214z",
    fill: "#F7C874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.101 45.977l1.23-.653c.09.092.178.188.265.283l-1.23.653a6.902 6.902 0 00-.265-.283z",
    fill: "#F7CA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.363 46.26l1.23-.653c.136.153.265.306.384.462l-1.23.653a11.908 11.908 0 00-.384-.462z",
    fill: "#F7CB7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.747 46.722l1.23-.653c.073.092.14.185.21.277L9.956 47a7.305 7.305 0 00-.21-.277z",
    fill: "#F7CA79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.957 47.002l1.23-.653.114.163-1.229.653-.115-.163z",
    fill: "#F7C874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.072 47.165l1.23-.653c.034.05.066.102.1.15l-1.229.652a2.255 2.255 0 00-.1-.15z",
    fill: "#F6C56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.174 47.314l1.229-.653c.031.048.063.096.09.144l-1.229.653-.09-.144z",
    fill: "#F6C267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.264 47.458l1.23-.653c.027.041.052.086.08.127l-1.23.653a2.553 2.553 0 00-.08-.127z",
    fill: "#F5BF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.341 47.585l1.23-.653.076.127-1.23.654c-.024-.042-.048-.087-.076-.128z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.418 47.712l1.23-.652.072.13-1.229.653c-.024-.045-.049-.086-.073-.13zM10.491 47.846l1.23-.653.073.134-1.23.653-.073-.134z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.565 47.98l1.229-.653c.024.045.045.09.07.134l-1.23.653c-.024-.045-.045-.09-.07-.134z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.634 48.114l1.23-.653.07.143-1.23.653c-.024-.048-.045-.095-.07-.143zM10.704 48.26l1.23-.653.073.153-1.23.653-.073-.153zM10.778 48.413l1.229-.653c.024.051.045.102.066.153l-1.23.653c-.02-.05-.044-.102-.065-.153zM10.844 48.566l1.23-.653.072.172-1.229.653c-.024-.057-.045-.114-.073-.172zM10.917 48.738l1.23-.653c.024.057.045.115.066.172l-1.23.653c-.02-.057-.045-.114-.066-.172zM10.984 48.91l1.229-.653c.024.06.045.121.066.182l-1.229.653c-.021-.06-.042-.121-.066-.182zM11.05 49.095l1.23-.653c.02.06.041.124.059.185l-1.23.653c-.02-.06-.038-.125-.06-.185z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.11 49.28l1.229-.653c.02.063.038.127.056.19l-1.23.654c-.017-.064-.038-.128-.056-.191zM11.169 49.474l1.229-.653.052.194-1.229.653-.052-.194zM11.221 49.668l1.23-.653c.017.067.03.134.048.201l-1.229.653c-.014-.067-.031-.134-.049-.2z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.267 49.866l1.229-.653.042.2-1.23.653-.041-.2zM11.308 50.07l1.23-.654c.014.07.024.14.034.214l-1.229.653c-.01-.07-.024-.14-.035-.214z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.343 50.28l1.23-.653c.01.07.02.143.027.213l-1.229.653a4.563 4.563 0 00-.028-.213zM11.375 50.493l1.229-.653c.01.076.017.153.024.23l-1.229.652a5.248 5.248 0 00-.024-.229z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.396 50.722l1.229-.652c.007.08.01.159.014.235l-1.23.653c0-.08-.006-.156-.013-.236zM11.413 50.958l1.23-.653.003.242v.007l-1.23.653V51.2c0-.08 0-.16-.003-.242z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.417 51.203l1.229-.653c0 .1 0 .195-.007.287l-1.23.653c.004-.092.008-.188.008-.287z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.406 51.49l1.23-.653c-.008.102-.015.2-.025.296l-1.23.653c.011-.095.022-.194.025-.296zM11.382 51.786l1.229-.653a7.675 7.675 0 01-.049.328l-1.23.653c.022-.105.04-.216.05-.328z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.333 52.114l1.229-.653c-.028.14-.06.271-.098.399l-1.229.653c.038-.128.07-.262.098-.399zM11.235 52.516l1.23-.653c-.374 1.236-1.29 1.962-2.379 2.739-.803.57-1.295 1.214-1.533 2l-1.23.653c.238-.79.73-1.43 1.534-2 1.09-.777 2.004-1.504 2.378-2.74z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32 57.255l1.23-.653c-.039.124-.07.252-.095.382l-1.229.653c.025-.13.056-.258.094-.382zM7.226 57.637l1.23-.653c-.022.105-.036.21-.05.319l-1.229.653c.014-.109.028-.217.05-.319zM7.177 57.96l1.23-.654c-.011.099-.022.198-.025.3l-1.23.652c.008-.101.015-.2.025-.299z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.153 58.255l1.229-.653c-.007.096-.007.195-.007.293l-1.23.653c0-.099 0-.197.008-.293z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.142 58.548l1.23-.653c0 .099 0 .198.007.3l-1.23.653c-.003-.102-.007-.201-.007-.3z",
    fill: "#F4B648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15 58.847l1.229-.652c0 .025 0 .05.003.076l-1.23.653c0-.026 0-.051-.003-.077z",
    fill: "#F4B648"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "error-empty_svg__paint0_linear_4473_29983",
    x1: 16.662,
    y1: 6.208,
    x2: 41.388,
    y2: 60.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "error-empty_svg__paint1_linear_4473_29983",
    x1: 15.488,
    y1: 67.632,
    x2: 44.822,
    y2: 67.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "error-empty_svg__paint2_linear_4473_29983",
    x1: 26.16,
    y1: 65.173,
    x2: 33.577,
    y2: 65.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "error-empty_svg__paint3_linear_4473_29983",
    x1: 2.169,
    y1: 41.6,
    x2: 64.441,
    y2: 41.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F7F9FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "error-empty_svg__clip0_4473_29983"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.961)",
    d: "M0 0h66.078v82H0z"
  })))));
}
export default SvgErrorEmpty;